import React from 'react'
import './styles/App.css'
import './styles/Responsive.css' // Import responsive styles

// Import your components
import Header from './components/Header'
import HeroSection from './components/HeroSection'
import Services from './components/Services'
import Testimonials from './components/Testimonials'
import PricingPlans from './components/PricingPlans'
import JoinSection from './components/JoinSection'
import FAQ from './components/FAQ'
import Contact from './components/Contact'
import Footer from './components/Footer'


function App() {
  return (
      <div className="app-container">
        <Header />
        {/* Hero with big image and heading */}
        <HeroSection />
        {/* Services row (מה השירותים שלנו?) */}
        <Services />
        {/* Testimonials */}
        <Testimonials />
        {/* Pricing plans */}
        <PricingPlans />
        {/* Join now CTA */}
        {/* <JoinSection /> */}
        {/* FAQ section */}
        <FAQ />
        {/* Contact section */}
        <Contact />
        {/* Footer */}
        <Footer />
      </div>
  )
}

export default App
